<template>
  <vuex-table
    :fields="fields"
    table_store="notify/notifications/table"
    class="table--content-middle"
  >
    <template #text="{ item }">
      <div v-if="item.type === 'predictive_export_stats_complete'">
        {{ item.i18n_props.text_body }}

        <span class="link" @click="download(item.params.path)">{{
          item.i18n_props.text_link
        }}</span>
      </div>

      <render-body v-else :item="item" />
    </template>

    <template #theme="{ item }">
      <z-alert-icon :type="item.theme" :size="24" />
    </template>
  </vuex-table>
</template>

<script>
  import ZAlertIcon from '@shared/components/icon/icon-alert';
  import RenderBody from '@notify/components/notifications/notifications-render-body';
  import { StatsService } from '@autocaller_v2/services/StatsService';
  import { downloadCSV } from '@/plugins/files';

  export default {
    components: {
      ZAlertIcon,
      RenderBody
    },
    computed: {
      fields: function () {
        return [
          {
            key: 'type',
            label: this.$t('notify.notification.field.type'),
            class: 'w-25',
            formatter: (value) => this.$t(`notify.notification.export_type.${value}`)
          },
          {
            key: 'text',
            label: this.$t('notify.notification.field.text'),
            class: 'w-100'
          },

          {
            key: 'created_at',
            label: this.$t('notify.notification.field.created_at'),
            class: 'text-nowrap px-4'
          }
        ];
      }
    },

    methods: {
      download(path) {
        StatsService.download(path)
          .then((response) => {
            downloadCSV(response.data, response.request.getResponseHeader('Content-Disposition'));
          })
          .catch((error) => this.$noty.server_error(error));
      }
    }
  };
</script>
